var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn", attrs: { id: "train-template" } },
    [
      _c(
        "b-row",
        { staticClass: "email-app" },
        [
          _c(
            "b-col",
            { attrs: { lg: "12" } },
            [
              !_vm.editorDataLoaded
                ? _c("main", { staticClass: "message bg-primary" }, [
                    _c("div", [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$t("TEMPLATE.TRAIN_BASE")))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.editorDataLoaded
                ? _c(
                    "b-card",
                    [
                      _c(
                        "content-placeholders",
                        [
                          _c("content-placeholders-img", {
                            staticStyle: { height: "765px" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.editorDataLoaded && _vm.trainTemplate.is_public
                ? _c(
                    "div",
                    { staticClass: "pull-right" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mt-2",
                          attrs: {
                            variant: "secondary",
                            target: "_blank",
                            href: "/submit/" + _vm.trainTemplate.template_doc_id
                          }
                        },
                        [_vm._v("Submit Form")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("main", { staticClass: "message bg-primary" }, [
                _vm.editorDataLoaded
                  ? _c(
                      "div",
                      [
                        _c("strong", [
                          _vm._v(" " + _vm._s(_vm.$t("TEMPLATE.TRAIN_BASE")))
                        ]),
                        _vm._v(
                          "   " + _vm._s(_vm.trainTemplate.title) + "\n        "
                        ),
                        _c("span", { staticClass: "badge badge-info mr-4" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.trainTemplate.status
                                  ? "COMMON.DONE"
                                  : _vm.$t("COMMON.NEW")
                              ) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _vm.trainTemplateData.revision_ids.length
                          ? _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.revisionVersionSelected,
                                    expression: "revisionVersionSelected"
                                  }
                                ],
                                on: {
                                  change: [
                                    function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.revisionVersionSelected = $event
                                        .target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    function($event) {
                                      _vm.fetchTemplateWithOutGaurd(
                                        $event.target.value
                                      )
                                    }
                                  ]
                                }
                              },
                              _vm._l(
                                _vm.trainTemplateData.revision_ids,
                                function(option, index) {
                                  return _c(
                                    "option",
                                    { key: index, domProps: { value: option } },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.$t("COMMON.VERSION")) +
                                          " " +
                                          _vm._s(option) +
                                          "\n          "
                                      )
                                    ]
                                  )
                                }
                              )
                            )
                          : _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.revisionVersionSelected,
                                    expression: "revisionVersionSelected"
                                  }
                                ],
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.revisionVersionSelected = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c("option", { attrs: { value: "1" } }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("COMMON.VERSION")) +
                                      " 1\n          "
                                  )
                                ])
                              ]
                            ),
                        _vm._v(" "),
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("TEMPLATE.ENABLE_AUTO_CORRECT")))
                        ]),
                        _vm._v(" "),
                        _c("c-switch", {
                          attrs: {
                            type: "3d",
                            variant: "success",
                            checked: _vm.trainTemplate.auto_correct_flag
                          },
                          on: {
                            change: function($event) {
                              _vm.autoCorrectSwitchChange($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "up-dn-btn" }, [
                          _c(
                            "div",
                            { staticClass: "btn-group import-export" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "import-export-button",
                                  attrs: {
                                    href:
                                      _vm.axios.defaults.baseURL.replace(
                                        "/api",
                                        ""
                                      ) + _vm.trainTemplateData.image_url,
                                    target: "_blank"
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-download" })]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isAdminRole
                            ? _c(
                                "div",
                                { staticClass: "btn-group import-export" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "import-export-button",
                                      on: { click: _vm.mappingDownload }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("TEMPLATE.EXPORT")))]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isAdminRole
                            ? _c(
                                "div",
                                { staticClass: "btn-group import-export" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "import-export-button",
                                      on: { click: _vm.showImportModal }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("TEMPLATE.IMPORT")) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.barCodePresent
                          ? _c(
                              "span",
                              { staticClass: "float-right" },
                              [
                                _c("strong", [_vm._v(" Barcode: ")]),
                                _vm._v(" "),
                                _c("span", { staticClass: "mr-4" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.trainTemplate.barcodes[0].value
                                      ) +
                                      " "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("strong", [_vm._v(" Barcode Type: ")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.trainTemplate.barcodes[0].barcode_type
                                    ) +
                                    "\n          "
                                ),
                                _vm.multipleBarCode
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "barcode-info",
                                        attrs: { id: "barcodeInfo" },
                                        on: { click: _vm.toggleShowMoreBarcode }
                                      },
                                      [
                                        _c("b", [
                                          _c("i", [
                                            _c("u", [
                                              _vm._v(_vm._s(_vm.showMoreText))
                                            ])
                                          ])
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-popover",
                                  {
                                    attrs: {
                                      target: "barcodeInfo",
                                      triggers: "click"
                                    }
                                  },
                                  [
                                    [
                                      _c("b-table", {
                                        attrs: {
                                          hover: "",
                                          fields: _vm.barcodeFields,
                                          items: _vm.trainTemplate.barcodes
                                        }
                                      })
                                    ]
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { lg: "3" } },
                    [
                      !_vm.mappingDataLoaded
                        ? _c("div", { staticClass: "template-mapping" }, [
                            _c(
                              "main",
                              { staticClass: "message" },
                              [
                                _c(
                                  "b-card",
                                  {
                                    attrs: {
                                      "header-tag": "header",
                                      "footer-tag": "footer"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "header" },
                                        slot: "header"
                                      },
                                      [
                                        _c("i", {
                                          attrs: {
                                            className: "fa fa-align-justify"
                                          }
                                        }),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.$t("TEMPLATE.MAPPINGS"))
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "content-placeholders",
                                      [
                                        _c("content-placeholders-text", {
                                          attrs: { lines: 29 }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        : _c("template-mappings", {
                            attrs: {
                              "template-mappings": this.mappingsData,
                              mappings: this.stage,
                              "is-latest-version": this.isLatestVersion
                            },
                            on: {
                              updated: _vm.mappingUpdated,
                              nodeSelected: _vm.showEditNode
                            }
                          }),
                      _vm._v(" "),
                      _c("new-mapping", {
                        attrs: {
                          "mappings-keys": this.mappingsKeys,
                          "show-new-mapping": this.showNewMapping,
                          "order-options": this.orderOptionsForNewMapping
                        },
                        on: {
                          created: _vm.mappingCreated,
                          cancelled: _vm.mappingCancelled
                        }
                      }),
                      _vm._v(" "),
                      _c("new-grouping", {
                        attrs: {
                          "mappings-keys": this.mappingsKeys,
                          "show-new-grouping": this.showNewGrouping,
                          "group-children": this.groupChildren,
                          "order-options": this.orderOptionsForNewMapping
                        },
                        on: {
                          created: _vm.groupCreated,
                          cancelled: _vm.groupCancelled
                        }
                      }),
                      _vm._v(" "),
                      _c("edit-mapping", {
                        attrs: {
                          "mappings-keys": this.mappingsKeys,
                          "show-edit-mapping": this.showEditMapping,
                          canvasElement: this.editShape,
                          "npi-groups": this.npiGroups,
                          stage: this.stage,
                          "order-options": this.orderOptionsForUpdateMapping
                        },
                        on: {
                          updated: _vm.mappingUpdated,
                          cancelled: _vm.updateCancelled
                        }
                      }),
                      _vm._v(" "),
                      _c("new-npiGrouping", {
                        attrs: {
                          "mappings-keys": this.mappingsKeys,
                          "show-new-npi-grouping": this.showNewNpiGrouping,
                          templateMappings: this.stage
                        },
                        on: {
                          created: _vm.npiGroupCreated,
                          cancelled: _vm.npiGroupCancelled
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col", { attrs: { lg: "9" } }, [
                    _c(
                      "main",
                      { staticClass: "message content-holder" },
                      [
                        _vm.editorDataLoaded
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-between toolbar-bg"
                              },
                              [
                                this.isLatestVersion ||
                                !this.trainTemplateData.revision_ids.length
                                  ? _c(
                                      "div",
                                      { staticClass: "action-bar-row" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "btn-group" },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover",
                                                    modifiers: { hover: true }
                                                  }
                                                ],
                                                attrs: {
                                                  variant: _vm.selectedAction(
                                                    "save"
                                                  ),
                                                  disabled: !this.enableSave(),
                                                  title: _vm.$t("TEMPLATE.SAVE")
                                                },
                                                on: {
                                                  click: _vm.saveDataFunction
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-floppy-o"
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "btn-group" },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover",
                                                    modifiers: { hover: true }
                                                  }
                                                ],
                                                attrs: {
                                                  variant: "light",
                                                  title: _vm.$t(
                                                    "TEMPLATE.THUMBNAIL"
                                                  )
                                                },
                                                on: {
                                                  click: _vm.toggleThumbnail
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-image"
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-dropdown",
                                          {
                                            staticClass: "theme",
                                            attrs: { variant: "light" }
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "button-content" },
                                              [
                                                _c("span", {}, [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("TEMPLATE.THEME")
                                                    ) + " "
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-dropdown-item",
                                              {
                                                class: {
                                                  selected: _vm.isThemeSelected(
                                                    "blue"
                                                  )
                                                },
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.updateTheme("blue")
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("COLOR.BLUE")
                                                    ) +
                                                    " "
                                                ),
                                                _c(
                                                  "b-badge",
                                                  {
                                                    attrs: { variant: "info" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t("COLOR.BLUE")
                                                        )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-dropdown-item",
                                              {
                                                class: {
                                                  selected: _vm.isThemeSelected(
                                                    "green"
                                                  )
                                                },
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.updateTheme("green")
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("COLOR.GREEN")
                                                    ) +
                                                    " "
                                                ),
                                                _c(
                                                  "b-badge",
                                                  {
                                                    attrs: {
                                                      variant: "success"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t("COLOR.GREEN")
                                                        )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-dropdown-item",
                                              {
                                                class: {
                                                  selected: _vm.isThemeSelected(
                                                    "red"
                                                  )
                                                },
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.updateTheme("red")
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("COLOR.RED")
                                                    ) +
                                                    " "
                                                ),
                                                _c(
                                                  "b-badge",
                                                  {
                                                    attrs: { variant: "danger" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t("COLOR.RED")
                                                        )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "btn-group" },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover",
                                                    modifiers: { hover: true }
                                                  }
                                                ],
                                                attrs: {
                                                  variant: "light",
                                                  title: _vm.$t(
                                                    "TEMPLATE.CREATE_NPI_GROUP"
                                                  )
                                                },
                                                on: {
                                                  click: _vm.showCreateNpiModal
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("TEMPLATE.NPI_GROUP")
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "older-version-message" },
                                      [
                                        _c(
                                          "strong",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "TEMPLATE.OLDER_VERSIONS"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "action-bar-row paginate-page"
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          title: _vm.$t("TEMPLATE.PREV_PAGE"),
                                          variant: "link",
                                          disabled: _vm.canGoToPrev
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.goToPage(_vm.prevPage)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              modifiers: { hover: true }
                                            }
                                          ],
                                          staticClass: "fa fa-arrow-left"
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "holder" }, [
                                      _c("span", { staticClass: "h4" }, [
                                        _vm._v(_vm._s(_vm.getCurrentPage))
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("COMMON.OF")) +
                                          " " +
                                          _vm._s(_vm.totalPages)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          title: _vm.$t("TEMPLATE.NEXT_PAGE"),
                                          variant: "link",
                                          disabled: _vm.canGoToNext
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.goToPage(_vm.nextPage)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              modifiers: { hover: true }
                                            }
                                          ],
                                          staticClass: "fa fa-arrow-right"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                this.isLatestVersion ||
                                !this.trainTemplateData.revision_ids.length
                                  ? _c(
                                      "div",
                                      { staticClass: "action-bar-row" },
                                      [
                                        _vm.isAdminRole
                                          ? _c(
                                              "div",
                                              { staticClass: "btn-group" },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover",
                                                        modifiers: {
                                                          hover: true
                                                        }
                                                      }
                                                    ],
                                                    ref: "selectIcon",
                                                    attrs: {
                                                      variant: _vm.selectedAction(
                                                        "select"
                                                      ),
                                                      title: _vm.$t(
                                                        "TEMPLATE.SELECT"
                                                      )
                                                    },
                                                    on: {
                                                      click: _vm.enableSelection
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-mouse-pointer"
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover",
                                                        modifiers: {
                                                          hover: true
                                                        }
                                                      }
                                                    ],
                                                    ref: "drawIcon",
                                                    attrs: {
                                                      variant: _vm.selectedAction(
                                                        "draw"
                                                      ),
                                                      title: _vm.$t(
                                                        "TEMPLATE.DRAW"
                                                      )
                                                    },
                                                    on: {
                                                      click: _vm.enableDraw
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-pencil"
                                                    })
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "btn-group" },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                attrs: { variant: "light" },
                                                on: { click: _vm.zoomIn }
                                              },
                                              [
                                                _c("i", {
                                                  directives: [
                                                    {
                                                      name: "b-tooltip",
                                                      rawName:
                                                        "v-b-tooltip.hover",
                                                      modifiers: { hover: true }
                                                    }
                                                  ],
                                                  staticClass:
                                                    "fa fa-search-plus",
                                                  attrs: {
                                                    title: _vm.$t(
                                                      "TEMPLATE.ZOOM_IN"
                                                    )
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-button",
                                              {
                                                attrs: { variant: "light" },
                                                on: { click: _vm.zoomOut }
                                              },
                                              [
                                                _c("i", {
                                                  directives: [
                                                    {
                                                      name: "b-tooltip",
                                                      rawName:
                                                        "v-b-tooltip.hover",
                                                      modifiers: { hover: true }
                                                    }
                                                  ],
                                                  staticClass:
                                                    "fa fa-search-minus",
                                                  attrs: {
                                                    title: _vm.$t(
                                                      "TEMPLATE.ZOOM_OUT"
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.isAdminRole
                                          ? _c(
                                              "div",
                                              { staticClass: "btn-group" },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover",
                                                        modifiers: {
                                                          hover: true
                                                        }
                                                      }
                                                    ],
                                                    attrs: {
                                                      disabled: !_vm.enableUndo,
                                                      variant: "light",
                                                      title: _vm.$t(
                                                        "TEMPLATE.UNDO"
                                                      )
                                                    },
                                                    on: { click: _vm.undo }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-undo"
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover",
                                                        modifiers: {
                                                          hover: true
                                                        }
                                                      }
                                                    ],
                                                    attrs: {
                                                      disabled: !_vm.enableRedo,
                                                      variant: "light",
                                                      title: _vm.$t(
                                                        "TEMPLATE.REDO"
                                                      )
                                                    },
                                                    on: { click: _vm.redo }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-repeat"
                                                    })
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isAdminRole
                                          ? _c(
                                              "div",
                                              { staticClass: "btn-group" },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover",
                                                        modifiers: {
                                                          hover: true
                                                        }
                                                      }
                                                    ],
                                                    attrs: {
                                                      disabled: !_vm.canDelete,
                                                      variant: _vm.selectedAction(
                                                        "delete"
                                                      ),
                                                      title: _vm.$t(
                                                        "TEMPLATE.DELETE_MAP"
                                                      )
                                                    },
                                                    on: {
                                                      click: _vm.showDeleteModal
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-trash"
                                                    })
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _c("div")
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "transition",
                          { attrs: { name: "fade" } },
                          [
                            _vm.showThumbnail
                              ? _c(
                                  "b-card",
                                  { staticClass: "thumbnail-holder" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "scrolling-wrapper-flexbox"
                                      },
                                      _vm._l(
                                        this.trainTemplateData.doc_thumbnails,
                                        function(thumbnail, index) {
                                          return _c(
                                            "b-card",
                                            {
                                              key: thumbnail["id"],
                                              class: {
                                                "thumbnail-card shadow": true,
                                                "thumbnail-selected": _vm.thumbnailSelected(
                                                  thumbnail["id"]
                                                )
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.goToPage(index)
                                                }
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "card-img-top",
                                                attrs: {
                                                  src: _vm._f("withBaseUrl")(
                                                    thumbnail["url"]
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "page-number" },
                                                [
                                                  _c("h4", [
                                                    _vm._v(_vm._s(index + 1))
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        }
                                      )
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "details" }, [
                          _c(
                            "div",
                            { staticClass: "content" },
                            [
                              _c("b-card", [
                                _c("div", {
                                  ref: "canvasEditor",
                                  staticClass: "hidden_cn",
                                  class: { draw_mode: this.draw },
                                  style: {
                                    maxHeight: this.containerHeight + "px"
                                  },
                                  attrs: { id: "container" }
                                })
                              ]),
                              _vm._v(" "),
                              _c("new-mapping")
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("context-menu", {
        attrs: {
          viewMenu: this.viewMenu,
          disableCut: this.contextMenu.cut.disabled,
          disableCopy: this.contextMenu.copy.disabled,
          disablePaste: this.contextMenu.paste.disabled,
          disableDelete: this.contextMenu.destroy.disabled,
          pageX: this.pageX,
          pageY: this.pageY
        },
        on: {
          cut: _vm.cutShape,
          copy: _vm.copyShape,
          paste: _vm.pasteShape,
          delete: _vm.destroyShape
        }
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "saveAlertModal",
          attrs: {
            title: _vm.$t("TEMPLATE.UNSAVE"),
            "ok-title": _vm.$t("COMMON.YES"),
            "cancel-title": _vm.$t("COMMON.NO"),
            "ok-variant": "secondary",
            "cancel-variant": "light",
            "hide-header-close": "",
            centered: ""
          },
          on: {
            ok: function($event) {
              _vm.saveDataFunction()
            },
            cancel: function($event) {
              _vm.discardData()
            }
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("TEMPLATE.SAVE_CHANGES")) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "deleteGroupModal",
          attrs: {
            title: "Delete Group",
            "ok-title": "Delete",
            "cancel-title": "Cancel",
            "ok-variant": "secondary",
            "cancel-variant": "light",
            "hide-header-close": "",
            centered: ""
          },
          on: {
            ok: _vm.deleteGroup,
            cancel: _vm.cancelDeleteGroup,
            hide: _vm.cancelDeleteGroup
          }
        },
        [
          _vm.deletableChildren.length > 0
            ? _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("h6", { staticClass: "pull-left select-mappings" }, [
                      _vm._v(_vm._s(_vm.$t("COMMON.MSG_SELECT_CHILD")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.deleteAll,
                          expression: "deleteAll"
                        }
                      ],
                      staticClass: "pull-left mt-1 mr-2",
                      attrs: { type: "checkbox", id: "delete_all" },
                      domProps: {
                        checked: Array.isArray(_vm.deleteAll)
                          ? _vm._i(_vm.deleteAll, null) > -1
                          : _vm.deleteAll
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.deleteAll,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.deleteAll = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.deleteAll = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.deleteAll = $$c
                            }
                          },
                          _vm.selectAllDeletableChildren
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "pull-left",
                        attrs: { for: "delete_all" }
                      },
                      [_vm._v("\n          Delete All\n        ")]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.deletableChildren, function(child) {
                    return _c(
                      "b-col",
                      { key: child.attrs.path, attrs: { cols: "6" } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedDeletableChildren,
                              expression: "selectedDeletableChildren"
                            }
                          ],
                          staticClass: "pull-left mt-1 mr-2",
                          attrs: { type: "checkbox", id: child.attrs.uniq_id },
                          domProps: {
                            value: child.attrs.uniq_id,
                            checked: Array.isArray(
                              _vm.selectedDeletableChildren
                            )
                              ? _vm._i(
                                  _vm.selectedDeletableChildren,
                                  child.attrs.uniq_id
                                ) > -1
                              : _vm.selectedDeletableChildren
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.selectedDeletableChildren,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = child.attrs.uniq_id,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.selectedDeletableChildren = $$a.concat(
                                      [$$v]
                                    ))
                                } else {
                                  $$i > -1 &&
                                    (_vm.selectedDeletableChildren = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.selectedDeletableChildren = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "pull-left",
                            attrs: { for: child.attrs.uniq_id }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(child.attrs.key) +
                                " " +
                                _vm._s(
                                  child.attrs.map_type === "shape"
                                    ? null
                                    : "( " + child.attrs.map_type + " )"
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    )
                  })
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "importModal",
          staticClass: "import-export-modal",
          attrs: { id: "modal", title: _vm.$t("TEMPLATE.UPLOAD_MAPPINGS") }
        },
        [
          _c("input", {
            ref: "file",
            attrs: { id: "fileUpload", type: "file" },
            on: {
              change: function($event) {
                _vm.handleFileUpload()
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: {
                    size: "sm",
                    variant: "secondary",
                    disabled: !_vm.isFileSelected
                  },
                  on: { click: _vm.saveImportMappings }
                },
                [_vm._v(" " + _vm._s(_vm.$t("CONFIGURED.CREATE")) + " ")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: { click: _vm.hideImportModal }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.CLOSE")) + " ")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "updateEsmAlert",
          attrs: {
            title: _vm.$t("TEMPLATE.ESMMAPPINGS"),
            "ok-title": _vm.$t("COMMON.YES"),
            "cancel-title": _vm.$t("COMMON.NO"),
            "ok-variant": "secondary",
            "cancel-variant": "light",
            "hide-header-close": "",
            centered: ""
          },
          on: {
            ok: function($event) {
              _vm.saveData(
                _vm.update_esm_status,
                _vm.esm_status,
                _vm.sv_status,
                _vm.cv_status
              )
            },
            cancel: function($event) {
              _vm.dontSaveEsmData()
            }
          }
        },
        [
          _c("p", [_vm._v(_vm._s(_vm.$t("TEMPLATE.TEMPLATE_VERSION_UPDATE")))]),
          _vm._v(" "),
          _vm._l(_vm.status_array, function(status, index) {
            return _c(
              "p",
              { key: status, staticClass: "text-left m-auto ml-md-auto" },
              [
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "2" } }),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "10" } }, [
                      _c("p", [
                        _vm._v(_vm._s(index + 1) + "." + _vm._s(status))
                      ])
                    ])
                  ],
                  1
                )
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "deleteMappings",
          attrs: {
            title: _vm.$t("TEMPLATE.DELETE_MODAL"),
            "ok-title": _vm.$t("COMMON.YES"),
            "cancel-title": _vm.$t("COMMON.NO"),
            "ok-variant": "secondary",
            "cancel-variant": "light",
            "hide-header-close": "",
            centered: ""
          },
          on: {
            ok: function($event) {
              _vm.deleteMapping()
            },
            cancel: function($event) {
              _vm.hideDeleteModal()
            }
          }
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("TEMPLATE.DELETE_MODAL_CONTENT")) + "\n  "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34f4f368", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34f4f368","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/templates/Train.vue
// module id = 1137
// module chunks = 2